import invariant from 'invariant';
import { listLoading, listError, listSuccess } from '../reducers/value-lists';
/**
 * Returns all value list action creators
 * @param  {string} type
 * @param  {Object} config
 * @return {Object}
 */

export function getActionCreators(type, config) {
  var api = config.api;
  return {
    fetch: {
      request: function request() {
        invariant(api && api.fetch, 'Please define a fetch function for this model in the config, e.g.\n\n' + ' const config = {\n' + '   valueLists: {\n' + '     api: {\n' + '       fetch: (type) => axios.get(\'/list\')\n' + '     }\n' + '    }\n' + ' }');
        return api.fetch(type);
      },
      reduce: {
        initial: listLoading,
        success: listSuccess,
        failure: listError
      }
    }
  };
}